import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_THRIWE_PRIME_BOOKING_ERROR, GET_THRIWE_PRIME_BOOKING_LIST, GET_THRIWE_PRIME_BOOKING_SUCCESS } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getThriwePrimeBookingList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/membership-purchase-logs`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'THRIWE_PRIME',
      },
      params: {
        pageIndex: payload?.urlParam?.pageIndex,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      // yield put({
      //   type: MAIN_AREA_LOADER_HIDE,
      // })

      yield put({
        type: GET_THRIWE_PRIME_BOOKING_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_THRIWE_PRIME_BOOKING_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_THRIWE_PRIME_BOOKING_ERROR, payload: error });
  }
}

export function* watchThriwePrimeBookingList() {
  yield takeEvery(GET_THRIWE_PRIME_BOOKING_LIST, getThriwePrimeBookingList);
}

function* thriwePrimeBookingListSaga() {
  yield all([fork(watchThriwePrimeBookingList)]);
}

export default thriwePrimeBookingListSaga;
